module.exports = __webpack_public_path__ + "static/media/sweeping.c0be3815.png";